var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._m(0), _c('v-data-table', {
    staticClass: "v-data-table--default v-data-table--no-active",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "page": _vm.page,
      "items-per-page": _vm.itemsPerPage,
      "hide-default-footer": "",
      "mobile-breakpoint": "0"
    },
    on: {
      "update:page": function updatePage($event) {
        _vm.page = $event;
      },
      "page-count": function pageCount($event) {
        _vm.pageCount = $event;
      }
    }
  }), _c('div', {
    staticClass: "v-pagination-wrap text-center"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "5"
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit top-line-tit"
  }, [_vm._v("CIS Nations")])]);
}]

export { render, staticRenderFns }